import supabase from "artifact/supabase";
import connected from "standard/connected";
import define from "standard/define";
import paint from "standard/paint";
import trait from "standard/trait";
import willPaint from "standard/willPaint";
import icon from "./icon.js";
import style from "./style";

@define("m-live")
class Live extends HTMLElement {
  #data;

  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  @willPaint
  async [trait.fetch]() {
    const { data: team } = await supabase
      .from("team")
      .select("class_id")
      .eq("school_id", this.dataset.school)
      .eq("user_id", this.dataset.user)
      .single();

    const { data } = await supabase
      .from("classroom")
      .select("daily_id")
      .eq("class_id", team.class_id)
      .single();

    this.#data = data;
  }

  @connected
  @paint
  [trait.template]() {
    return `
      <a class="${style.liveCreate}" href='/app/${this.dataset.user}/${this.dataset.school}/live/${this.#data.daily_id}' target='_blank'>
        ${icon.camera()}
        Acessar aula
      </a>
    `;
  }
}

export default Live;
